import Image from "next/image";
import { twMerge } from "tailwind-merge";

interface SmallVideoCardProps {
    title?: string;
    duration?: string;
    img: string;
    bgPlayColor?: string;
    free?: boolean;
    playCenter?: boolean;
}

export default function SmallVideoCard({
    title,
    duration,
    img = "/images/RicoPlaceholder.png",
    bgPlayColor = "bg-neutral-400",
    free = false,
    playCenter = false,
}: SmallVideoCardProps) {
    return (
        <>
            <div className="lg:w-[350px] w-[330px] md:w-[260px] h-[184px] aspect-video rounded-lg  justify-center items-center inline-flex group">
                <Image
                    className=" border border-neutral-700  aspect-video rounded-md"
                    src={img}
                    alt=""
                    height={184}
                    width={360}
                    style={{ objectFit: "cover" }}
                />
                {free && (
                    <>
                        {playCenter ? (
                            <>
                                <div className="absolute ">
                                    <div
                                        className={twMerge(
                                            "w-12 h-12 p-2 bg-opacity-20 rounded-lg justify-start items-center gap-1 inline-flex",
                                            bgPlayColor,
                                        )}
                                    >
                                        <Image
                                            alt=""
                                            height={50}
                                            width={50}
                                            src="/Icons/playIconWhite.svg"
                                            className="w-6 h-6 relative"
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="lg:w-[350px] w-[330px] md:w-[260px] space-y-1 h-20 flex-col -mt-10 justify-start items-start gap-1 flex absolute">
                                    <div className="group-hover:scale-105 duration-500 ease-in-out p-2 w-16 h-16 bg-cyan-600 bg-opacity-50 rounded-lg justify-start items-start gap-1 inline-flex">
                                        <div
                                            className={twMerge(
                                                "w-12 h-12 p-2 bg-opacity-20 rounded-lg justify-start items-center gap-1 inline-flex",
                                                bgPlayColor,
                                            )}
                                        >
                                            <Image
                                                alt=""
                                                height={50}
                                                width={50}
                                                src="/Icons/playIconWhite.svg"
                                                className="w-6 h-6 relative"
                                            />
                                        </div>
                                    </div>
                                    <div className="space-y-3">
                                        <div className="ml-3 text-white md:line-clamp-1 line-clamp-2 text-lg font-bold  leading-5">
                                            {title}
                                        </div>
                                        <div className="ml-3 text-white text-left  leading-none">
                                            {duration}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {!free && (
                    <div className="absolute mt-36 -ml-56">
                        <div className="w-[103px] h-8 px-2 py-1 bg-neutral-800 bg-opacity-60 rounded-[100px] justify-start items-center gap-1 inline-flex">
                            <Image
                                alt=""
                                width={40}
                                height={40}
                                src="/Icons/lockWhite.svg"
                                className="w-6 h-6 relative"
                            />
                            <div className="text-center text-white text-base font-normal  leading-normal">
                                Buy now
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
